import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ItemIdAssetModal from "../../../views/shopping/Orders/ItemIdAssetModal";
import { ProjectProvider } from "../../../contexts/project";

export default function AssetCard({ asset }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const handleClick = () => {
    setDetailsOpen(true);
  };

  // Get the default image or first available image
  const defaultImage = asset.images?.find(img => img.default) || asset.images?.[0];
  const imageUrl = defaultImage?.url;

  return (
    <>
      <Box 
        onClick={handleClick}
        sx={{ 
          display: "flex",
          gap: 3,
          p: 2,
          maxWidth: "500px",
          width: "100%",
          border: "1px solid",
          borderColor: "grey.300",
          borderRadius: 1,
          bgcolor: "transparent",
          cursor: "pointer",
          transition: "all 0.2s",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            borderColor: "grey.400"
          }
        }}
      >
        {/* Image */}
        <Box
          sx={{
            width: 80,
            height: 80,
            flexShrink: 0,
            borderRadius: 0.5,
            overflow: "hidden",
            bgcolor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid",
            borderColor: "grey.200"
          }}
        >
          {imageUrl ? (
            <img 
              src={imageUrl} 
              alt={asset.description}
              style={{ 
                width: "100%", 
                height: "100%", 
                objectFit: "cover" 
              }}
            />
          ) : (
            <Typography variant="caption" color="text.secondary">
              No image
            </Typography>
          )}
        </Box>

        {/* Content */}
        <Box flex={1} display="flex" flexDirection="column" justifyContent="center" gap={0.5}>
          <Typography variant="body1" color="text.secondary" fontSize="15px" fontWeight={500}>
            {asset.itemId}
          </Typography>
          <Typography variant="body1" color="text.secondary" fontSize="15px">
            {asset.description}
          </Typography>
          {asset.warehouseQuantity > 0 && (
            <Typography variant="body2" color="text.secondary" fontSize="14px" sx={{ mt: 0.5 }}>
              Highmark Quantity: {asset.warehouseQuantity}
            </Typography>
          )}
        </Box>
      </Box>

      {detailsOpen && asset.project?.id && (
        <ProjectProvider id={asset.project.id} loadingComponent={<span />}>
          <ItemIdAssetModal id={asset.id} onClose={() => setDetailsOpen(false)} />
        </ProjectProvider>
      )}
    </>
  );
}
